import { createIconComponent } from '../../factory/create-icon-component';
export const TruckIcon = createIconComponent(
  'TruckIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 19C20 20.6569 18.6569 22 17 22C15.3431 22 14 20.6569 14 19M20 19C20 17.3431 18.6569 16 17 16C15.3431 16 14 17.3431 14 19M20 19C21.6569 19 23 17.6569 23 16V6.8C23 5.11984 23 4.27976 22.673 3.63803C22.3854 3.07354 21.9265 2.6146 21.362 2.32698C20.7202 2 19.8802 2 18.2 2H15.8C14.1198 2 13.2798 2 12.638 2.32698C12.0735 2.6146 11.6146 3.07354 11.327 3.63803C11 4.27976 11 5.11984 11 6.8V8M14 19H10M10 19C10 20.6569 8.65685 22 7 22C5.34315 22 4 20.6569 4 19M10 19C10 17.2034 8.5 16 7 16C5.34315 16 4 17.3431 4 19M4 19C3.06812 19 2.60218 19 2.23463 18.8478C1.74458 18.6448 1.35523 18.2554 1.15224 17.7654C1 17.3978 1 16.9319 1 16V12.7727C1 12.1129 1 11.783 1.05245 11.4623C1.07799 11.3061 1.11275 11.1518 1.1565 11M1.1565 11C1.19254 10.875 1.23469 10.7517 1.28282 10.6306C1.40284 10.3286 1.57257 10.0457 1.91205 9.47992L2.19926 9.00123C2.81699 7.97169 3.12585 7.45692 3.54001 7.07157C3.99933 6.64419 4.55274 6.33086 5.15552 6.15688C5.69905 6 6.29937 6 7.5 6H8H9.2C10.1941 6 11 6.80589 11 7.8C11 8.92011 11 9.48016 10.782 9.90798C10.5903 10.2843 10.2843 10.5903 9.90798 10.782C9.48016 11 8.9201 11 7.8 11H4.5H1.1565Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
